import { bbc, bbcserif } from 'src/theme/adSales/fonts'
import { gelTypeStyles } from 'src/theme/adSales/gel'

const generateThemeTypeStyles = (gelTypeStyles: any) => ({
  dataLarge: {
    ...gelTypeStyles.imperial,
    fontWeight: 'bold',
    fontFamily: bbc
  },
  headlineSerif: {
    ...gelTypeStyles.foolscap,
    fontWeight: 'regular',
    fontFamily: bbcserif
  },
  headlineSans: {
    ...gelTypeStyles.foolscap,
    fontWeight: 'medium',
    fontFamily: bbc
  },
  sectionTitleSerif: {
    ...gelTypeStyles.trafalgar,
    fontWeight: 'medium',
    fontFamily: bbcserif
  },
  girdCardSectionTitleSerif: {
    ...gelTypeStyles.trafalgar,
    fontWeight: 'medium',
    fontFamily: bbcserif,
    fontSize: '28px'
  },
  sectionTitleSans: {
    ...gelTypeStyles.trafalgar,
    fontWeight: 'medium',
    fontFamily: bbc
  },
  primaryHeadlineSerif: {
    ...gelTypeStyles.paragon,
    fontWeight: 'medium',
    fontFamily: bbcserif
  },
  primaryHeadlineSans: {
    ...gelTypeStyles.paragon,
    fontWeight: 'medium',
    fontFamily: bbc
  },
  sectionSubTitleSerif: {
    ...gelTypeStyles.doublePica,
    fontWeight: 'medium',
    fontFamily: bbcserif
  },
  sectionSubTitleSans: {
    ...gelTypeStyles.doublePica,
    fontWeight: 'medium',
    fontFamily: bbc
  },
  labels: {
    ...gelTypeStyles.greatPrimer,
    fontWeight: 'medium',
    fontFamily: bbc
  },
  labelsSerif: {
    ...gelTypeStyles.greatPrimer,
    fontWeight: 'medium',
    fontFamily: bbcserif
  },
  labelsEmphasised: {
    ...gelTypeStyles.greatPrimer,
    fontWeight: 'bold',
    fontFamily: bbc
  },
  body: {
    ...gelTypeStyles.bodyCopy,
    fontWeight: 'regular',
    fontFamily: bbc
  },
  bodyEmphasised: {
    ...gelTypeStyles.bodyCopy,
    fontWeight: 'bold',
    fontFamily: bbc
  },
  metaData: {
    ...gelTypeStyles.brevier,
    fontWeight: 'regular',
    fontFamily: bbc
  },
  metaDataEmphasised: {
    ...gelTypeStyles.brevier,
    fontWeight: 'bold',
    fontFamily: bbc
  }
})

export const themeTypeStyles = generateThemeTypeStyles(gelTypeStyles)

export const fontSizes = {
  dataLarge: themeTypeStyles.dataLarge.fontSize,
  headline: themeTypeStyles.headlineSans.fontSize,
  sectionTitle: themeTypeStyles.sectionTitleSans.fontSize,
  labels: themeTypeStyles.labels.fontSize,
  body: themeTypeStyles.body.fontSize,
  metaData: themeTypeStyles.metaData.fontSize
}

export const lineHeights = {
  dataLarge: themeTypeStyles.dataLarge.lineHeight,
  headline: themeTypeStyles.headlineSans.lineHeight,
  sectionTitle: themeTypeStyles.sectionTitleSans.lineHeight,
  labels: themeTypeStyles.labels.lineHeight,
  body: themeTypeStyles.body.lineHeight,
  metaData: themeTypeStyles.metaData.lineHeight
}

export const fontWeights = {
  thin: 100,
  light: 300,
  regular: 400,
  medium: 500,
  bold: 700,
  extraBold: 900
}

export type ThemeTypography = typeof themeTypeStyles
